<template>
  <div class="color-picker-popover-root">
    <el-popover
      trigger="click"
      :placement="placement"
      :teleported="true"
      popper-class="color-picker-popover"
    >
      <template #reference>
        <slot />
      </template>
      <div class="color-picker-popover__body">
        <el-color-picker-panel :model-value="modelValue" @update:model-value="onChange" />
      </div>
    </el-popover>
  </div>
</template>

<script setup lang="ts">
  import { ElPopover, ElColorPickerPanel } from 'element-plus';
  import type { Placement } from 'element-plus';

  defineProps<{
    placement?: Placement;
  }>();

  const modelValue = defineModel<string>({ default: '' });

  function onChange(val: string | null) {
    if (val && val !== modelValue.value) modelValue.value = val;
  }
</script>

<style>
  .color-picker-popover {
    width: auto !important;
    min-width: 326px !important;
    padding: 0 !important;
  }

  .color-picker-popover__body {
    width: 326px;
  }
</style>
